/**
 * 0zzz-uhy round 2: ONE reader for the caller's own organization list (`organizationAPI.getAll()`).
 *
 * An answer without a real `organizations` array is a FAILED load, never "the user has no organizations". Coercing it
 * with `|| []` told a member "you are not part of any organization" (picker), could create a duplicate personal org
 * (registration) and, on /safeword, showed the zero-hierarchy dead end. Every reader of this endpoint goes through
 * here so a missing array throws and each caller's existing failure path runs.
 *
 * `body` is the axios `response.data` (wrapped `{ data: {...} }` or bare).
 */
import { unwrapResponse } from './unwrapResponse';

export function extractOrganizationList<T = any>(body: unknown): T[] {
  const organizations = (unwrapResponse<{ organizations?: unknown }>(body as never) as { organizations?: unknown } | null | undefined)?.organizations;
  if (!Array.isArray(organizations)) {
    throw new Error('Organization list response had no organizations array');
  }
  return organizations as T[];
}
